import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFile from '../Shared/ChunkedUploadFile';
import './ProductionUploadFile.css';

const PRODUCTION_ROOT =
  process.env.REACT_APP_PRODUCTION_START_PATH || '/production';

function ProductionUploadFile({ currentPath, userId, onFileUploaded }) {
  return (
    <ChunkedUploadFile
      currentPath={currentPath}
      userId={userId}
      onFileUploaded={onFileUploaded}
      rootPath={PRODUCTION_ROOT}
      sessionPrefix="production_file"
    />
  );
}

ProductionUploadFile.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFileUploaded: PropTypes.func,
};

export default ProductionUploadFile;
